import { apiGet, apiPost, createApiUrl } from '@/utils/apiUtils'
import type {
  UserOrganizationResponse,
  UserOrganizationsResponse,
} from '@server/types/responseTypes'

export const fetchOrganizations = async () => {
  const res = await apiGet<UserOrganizationsResponse>(
    createApiUrl('organizations'),
  )
  return res.data
}

export const createOrganization = async (name: string) => {
  const res = await apiPost<UserOrganizationResponse>(
    createApiUrl('organizations'),
    { name },
  )
  return res.data
}
